export default __webpack_public_path__ + "static/char-14-f99e4aea89a809368507a4c63f2f595b.webp";